module.exports = __webpack_public_path__ + "static/img/price3.f43c749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/price3.png
// module id = oFmi
// module chunks = 36